export default {
  slug: 'personas-engagement',
  title: 'Personas & engagement',
  description: 'Controlled identities, decoy assets, and intake endpoints.',
  section: 'engagement',
  order: 1,
  tags: ['personas', 'agents', 'listeners', 'engagement'],
  body: `# Personas & engagement

Engagement modules support **authorized controlled operations** — personas, decoy assets, intake endpoints, and workflows.

> **Authorization required.** Use only within lawful investigative scope and organizational policy.

## Personas

**[Engagement → Personas](/personas)** manages controlled identities (aliases, platforms, status). Personas link to cases and appear in relationship tables and graphs.

## Decoy assets (agents)

**[Decoy Assets](/agents)** — registered endpoints that beacon to intake infrastructure. The sidebar badge shows online count.

Agent detail pages cover beacon interval, tasks, and activity.

## Intake endpoints (listeners)

**[Intake Endpoints](/listeners)** — C2-style listeners that receive agent callbacks. Managed separately from case data.

## Workflows & console

| Module | Route | Purpose |
|--------|-------|---------|
| Workflows | \`/tasks\` | Task queue and execution |
| Analyst Console | \`/console\` | Live operator console |
| Artifact Deploy | \`/payloads\` | Staged artifact generation |
| Map | \`/map\` | Geographic agent view |

## Separation from intelligence

Intelligence enrichment is **passive OSINT**. Engagement modules are **active** — keep case notes and audit logs current when running engagement alongside enrichment.
`,
};
